var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 150,
    x2: 234,
    y1: 119.2,
    y2: 264.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M512 306H304l-35.9-31.4a18.4 18.4 0 00-24.2 0L208 306H0V0h512Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 384 384"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 192,
    r: 84,
    fill: "url(#a)",
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    d: "M192 61.7V12m0 360v-49.7m92.2-222.5 35-35M64.8 319.2l35.1-35.1m0-184.4-35-35m254.5 254.5-35.1-35.1M61.7 192H12m360 0h-49.7"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 192 192; 45 192 192"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 384,
    height: 384,
    transform: "translate(64 100)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#374151",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 18,
    d: "M128 332h88l40-36 40 36h88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.896f5a009d92f80ea351ff3705b632fa.svg";
export { ForwardRef as ReactComponent };